<template>
  <div>
    <div class="position-relative w-100">
      <b-form-input
        readonly
        :value="selectedValue"
        placeholder="Выберите виды работ..."
        class="pointer-cell"
        @click="showModal"
      />
      <div class="select-input-body-wrapper">
        <button type="button" class="custom-btn-select" @click.stop="onIconClick">
          <v-icon v-if="selected.length > 0" name="buttons/cross" :size="11"/>
          <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
        </button>
      </div>
    </div>

    <b-modal
      ref="vacancy_multi_select_modal"
      title="Вакансии"
      size="xl"
      modal-class="custom-modal"
      @close="onCancel"
      scrollable
    >
      <div class="page-body">
        <div class="page-filters">
          <div class="d-flex align-items-center">
            <b-input-group>
              <b-form-input size="sm" v-model="query" :placeholder="$t('message.common.search')"/>
              <b-input-group-append>
                <button type="button" class="search-btn" @click.stop="onSearch()">
                  <v-icon name="buttons/search"/>
                </button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <template v-if="isBusy || (items && items.length > 0)">
          <div class="page-table-container">
            <b-table
              id="vacancy-multi-select-table"
              ref="vacancy_multi_select_table"
              class="custom-table text-small mb-0"
              responsive
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              @row-clicked="rowClicked"
              :tbody-tr-class="tbodyRowClass"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
              no-local-sorting
              @sort-changed="sortChanged"
            >
              <template #table-busy>
                <tables-skeleton :fields="fields" :rows="5"/>
              </template>
            </b-table>
          </div>

          <div class="page-pagination">
            <pagination-footer
              :total-rows="totalRows"
              :per-page.sync="perPage"
              :current-page="currentPage"
              @page-change="(page) => onPagination(null, page)"
              @per-page-change="onPerPageChange"
            />
          </div>
        </template>

        <div v-else class="empty-state-container">
          <v-icon name="navbar/empty_table" :size="90"/>
          <h5>{{ isFiltered ? 'Нет данных соответствующих фильтрам.' : 'Нет добавленных исполнителей.' }}</h5>
        </div>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <p class="float-left">Выбраны: {{ tempSelected.length }}</p>
          <b-button class="custom-btn-primary" @click="onOk">
            Применить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import helpers from "../../../utilites/helpers";
  import PaginationFooter from "../../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../../utilites/pageSearchService";
  import TablesSkeleton from "../../../utilites/commonUi/TablesSkeleton.vue";

export default {
  name: "VacancyMultiSelect",
  components: { TablesSkeleton, PaginationFooter },
  mixins: [
    catalogs,
    helpers, pageSearchService
  ],
  props: {
    title: {type: String, default: "Вакансии"},
    isDisabled: { type: Boolean, default: false },
    initialItems: { type: Array, default: null },
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      query: '',
      items: [],
      selected: [],
      tempSelected: [],
      isBusy: false,
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'text-center',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true,
        },
      ],
      sortBy: 'id',
      sortDesc: true,
    }
  },
  computed: {
    selectedValue() {
      if (this.selected.length === 0) {
        return this.title;
      }
      return `${this.title} ${this.selected.length}`;
    },
    isFiltered() {
      return !!this.query && this.query.trim().length > 0;
    },
  },
  methods: {
    async configure(ids) {
      let list = [];
      for (const index in ids) {
        const id = parseInt(ids[index]);
        if (id != null) {
          let item = null;

          if (this.initialItems) {
            item = this.initialItems.find(u => u.id === id);
          }

          if (!item) {
            const result = await this.getVacancyById(id);
            item = result.data;
          }

          if (item != null) {
            list.push(item);
          }
        }
      }
      this.selected = list;
    },
    async showModal() {
      this.tempSelected = [...this.selected];
      this.$refs.vacancy_multi_select_modal.show();
      await this.getItems();
    },
    onClearSelected() {
      this.selected = [];
      this.$emit('onSelect', this.selected);
    },
    onClearQuery() {
      this.query = '';
    },
    onOk() {
      this.selected = [...this.tempSelected];
      this.$emit('onSelect', this.selected);
      this.$refs.vacancy_multi_select_modal.hide();
    },
    onCancel() {
      this.tempSelected = [];
      this.query = '';
    },
    rowClicked(item) {
      // Ищем уже выбранные
      const existItem = this.tempSelected.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.tempSelected.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.tempSelected.push(item);
        this.$set(item, 'selected', true);
      }
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    async getItems() {
      if (this.initialItems) {
        let filteredItems = this.initialItems;

        if (this.query) {
          const lowerQuery = this.query.toLowerCase();
          filteredItems = filteredItems.filter(u =>
            (u.name.toLowerCase().includes(lowerQuery)) ||
            (u.id.toString().includes(this.query))
          );
        }

        this.totalRows = filteredItems.length;
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;

        this.items = filteredItems.slice(start, end);
        this.updateSelected();
        return;
      }

      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query.toLowerCase(),
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      const result = await this.getVacancies(data);

      if (!result || !result.data) {
        this.items = [];
        this.totalRows = 0;
        return;
      }

      this.totalRows = result.data.total;
      this.items = result.data.items;
      this.updateSelected();
    },
    updateSelected() {
      if (!this.items) return;

      this.items.forEach((item) => {
        const isSelected = this.tempSelected.some(e => e.id === item.id);
        this.$set(item, 'selected', isSelected);
      });
    },
    onIconClick() {
      if (this.selected.length) {
        this.onClearSelected();
      } else {
        this.showModal();
      }
    }
  },
  watch: {
    query: {
      async handler() {
        if (this.query) {
          this.currentPage = 1;
          await this.getItems();
        }
      }, deep: true
    },
    value: {
      handler(newIds) {
        if (!newIds) {
          this.selected = [];
          return;
        }

        this.configure(newIds);
      }, deep: true, immediate: true
    }
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/VacancyMultiSelect.vue